import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api, storageUrl } from "../api";
import { formatPrice } from "../data/currency";
import { LibraryCardSkeleton } from "../components/Skeleton";

function Library() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/library").then(setGames).finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="library">
      <h2>My Games</h2>
      <div className="library-grid">
        {Array.from({ length: 4 }).map((_, i) => (
          <LibraryCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );

  if (games.length === 0) {
    return (
      <div className="library-empty">
        <h2>My Games</h2>
        <p>You haven't purchased any games yet.</p>
        <Link to="/" className="browse-link">Browse Games</Link>
      </div>
    );
  }

  return (
    <div className="library">
      <h2>My Games ({games.length})</h2>
      <div className="library-grid">
        {games.map((game) => {
          const cat = game.category;
          const latest = game.versions?.[0];
          return (
            <div key={game.id} className="library-card">
              <img src={storageUrl(game.thumbnail_path)} alt={game.title} />
              <div className="library-card-body">
                <h3>{game.title}</h3>
                <span className="game-card-genre">{cat ? cat.name : ""}</span>
                <p className="library-card-price">{formatPrice(game.price)}</p>
                {latest?.download_path && (
                  <a
                    href={latest.download_path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="download-btn-sm"
                  >
                    Download v{latest.version}
                  </a>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Library;
